import { computed, Injectable, signal } from '@angular/core';
import { UserRole } from '../../shared/model/role';
import { Router } from '@angular/router';
import { NAVIGATION } from './navigation.config';
import { IPageSelector, ISubMenu } from './navigation.model';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly role = signal<UserRole>(this.getRole());

  readonly pageSelectors = computed<IPageSelector[]>(() => {
    const currentRole = this.role();

    return NAVIGATION()
      .filter(page => page.roles.includes(currentRole))
      .map(page => ({
        ...page,
        children: page.children?.filter(child =>
          child.roles.includes(currentRole)
        )
      }));
  });

  readonly currentPage = signal<IPageSelector | null>(null);

  readonly currentSubMenu = computed<ISubMenu[]>(() => {
    return this.currentPage()?.children ?? [];
  });

  constructor(private router: Router) { }

  getRole(): UserRole {
    const role = localStorage.getItem('userRole');

    return role as UserRole ?? UserRole.USER;
  }

  setRole(role: UserRole): void {
    this.role.set(role);
  }

  setCurrentPage(page: IPageSelector): void {
    this.currentPage.set(page);
  }

}
